module.exports = __webpack_public_path__ + "static/media/News_App.1096e66a.png";